import http from '@/http'
const URL = '/admin/hotels/rooms'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?include=rooms`))
  }
  return one
}

export const saveRoom = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const delRoom = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.id}/status`, payload)

export default {
  list,
  show,
  saveRoom,
  delRoom,
  changeStatus
}
